import { Stack } from '@mui/material'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { setMainSelection, useListApi } from '@/atoms'
import { selectOrderStepIdsInRange, selectOrderSteps } from '@/features/domain/order'
import { selectUserConfiguration } from '@/features/domain/user'
import { timeUtils } from '@/server-data'

import { useTexts } from '../useTexts'

export function useGoToPairedButtonData(extOrder: uui.domain.client.rm.ExtendedOrderStep) {
  const orderStepIdsInRange = useSelector(selectOrderStepIdsInRange)
  const extOrderSteps = useSelector(selectOrderSteps)
  const userConfig = useSelector(selectUserConfiguration)
  const { scrollTo } = useListApi('orderSteps')
  const texts = useTexts()

  const goToPaired = useCallback(() => {
    // If the order is not a pickup&dropoff order, do nothing
    if (extOrder.type !== 'pd') return

    // Set the main selection to the paired order step and scroll to it
    setMainSelection('orderSteps', [extOrder.pairedId])
    scrollTo(extOrder.pairedId)
  }, [extOrder])

  const hasPaired = extOrder.type === 'pd'
  const isPairedInRange = hasPaired && orderStepIdsInRange[extOrder.pairedId] === true
  const pairedOrderStep = hasPaired ? extOrderSteps[extOrder.pairedId] : undefined
  const vehicleName = pairedOrderStep?.hasVehicle ? pairedOrderStep.vehicleName : ''
  const date =
    !pairedOrderStep?.isUnassigned && pairedOrderStep?.dateAsString
      ? timeUtils.formatDate(userConfig)(pairedOrderStep.dateAsString)
      : ''

  const goToPairedTooltip = isPairedInRange ? (
    texts.goToPaired(extOrder.orderStepType)
  ) : (
    <Stack spacing={1}>
      <span>{texts.pairedOutOfRangeTooltipTitle(extOrder.orderStepType, extOrder.order.name)}</span>
      <span>
        {texts.pairedOutOfRangeTooltipSubtitle(extOrder.orderStep.type, vehicleName, date)}
      </span>
    </Stack>
  )

  return {
    hasPaired,
    goToPaired,
    goToPairedTooltip,
    goToPairedDisabled: !isPairedInRange,
  }
}
